function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g4243",
    transform: "matrix(0.09257195,0.03834456,-0.03829287,0.09244716,0.78401958,-11.698894)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 431.50561,295.20504 C 432.82327,387.10269 379.36552,465.9166 289.11267,465.47088 198.85979,465.02516 138.37646,412.59732 138.35401,286.32386 138.32008,159.75897 212.2697,20.904869 280.27565,19.42096 352.8144,17.772616 429.52425,155.37831 431.50561,295.20504 Z",
    id: "path2167",
    style: {
      fill: "rgba(250,250,250,1)",
      fillRule: "evenodd",
      stroke: "#6f5499",
      strokeWidth: 9.98685741,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.2e92f71913f42fde5926c15c36c15705.svg";
export { ForwardRef as ReactComponent };